/**
 * The attributes and events of older WebKit engines need to be prefixed, as per
 * https://webostv.developer.lge.com/develop/app-developer-guide/web-app-lifecycle/#AppVisibility
 * For more information, also check
 * https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
 * https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilityState
 * @param document
 */
export function detectPageVisibilityApi(document) {
    let hiddenAttribute = 'hidden';
    let visibilityChangeEvent = 'visibilitychange';
    let visibilityStateKey = 'visibilityState';
    if (typeof document.hidden === 'undefined' && typeof document.webkitHidden !== 'undefined') {
        // To support older WebKit engines
        hiddenAttribute = 'webkitHidden';
        visibilityChangeEvent = 'webkitvisibilitychange';
        visibilityStateKey = 'webkitVisibilityState';
    }
    return { hiddenAttribute, visibilityChangeEvent, visibilityStateKey };
}
//# sourceMappingURL=page-visibility-api.js.map